enum InboxViewTypes {
  Influencer = 'influencer',
}

export { InboxViewTypes }
